<script setup lang="ts">
import type { HTMLAttributes } from "vue";

const props = defineProps<{
    class?: HTMLAttributes["class"];
}>();
</script>

<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="23"
        height="20"
        viewBox="0 0 23 20"
        fill="none"
        :class="props.class"
    >
        <path
            d="M19.5 18.8243C19.5 19.3766 19.0523 19.8243 18.5 19.8243H4.5C3.94772 19.8243 3.5 19.3766 3.5 18.8243V9.82434H0.5L10.8273 0.435844C11.2087 0.0890937 11.7913 0.0890937 12.1727 0.435844L22.5 9.82434H19.5V18.8243ZM10.5 11.8243V17.8243H12.5V11.8243H10.5Z"
            :fill="props.class ? 'currentColor' : '#FF6971'"
        />
    </svg>
</template>
